/**
 * The clipboard half of the join dialog's Paste invite button (ISSUE-1340).
 * Kept apart from the dialog so the browser checks and the copy can be
 * asserted without rendering it.
 */

/** Shown when the browser refuses the clipboard read. */
export const PASTE_REFUSED_MESSAGE =
  "We couldn't read your clipboard. Paste the invite into the box instead.";

/** Shown when the clipboard holds no invite code or invite link. */
export const PASTE_NO_CODE_MESSAGE =
  "That doesn't look like an invite. Copy the whole invite link and try again.";

/**
 * True when this browser lets a page read the clipboard on a tap. An older
 * browser without it gets no button rather than one that always fails.
 */
export function canReadClipboard(
  nav: Pick<Navigator, "clipboard"> | undefined = typeof navigator ===
  "undefined"
    ? undefined
    : navigator,
): boolean {
  return typeof nav?.clipboard?.readText === "function";
}
